<template>
	<div>
		<div class="title">
			<div class="flex">
				<div style="background-color: #008200;width: 5px;height: 20px;"></div>
				<div style="margin-top: -2px; font-weight: 800;margin-left: 3px;">门店成本详情</div>
			</div>
			<el-button size="small" style="float: right;margin-top: -30px;"><i class="el-icon-refresh">刷新</i>
			</el-button>
		</div>
		<div class="box">
			<div class="stitle flex">
				<div style="flex: 10;">
					{{this.$route.query.storeName}}
				</div>
			</div>
			<div style="float: right;margin: -50px 15px 20px 0">
				<el-button @click="back01()">返回</el-button>
				<el-button @click="exprot()" type="primary">导出</el-button>
			</div>
			<div style="padding: 0 15px 0 15px;margin-top: 10px;">
				<el-table :data="tableData" :cell-style="{'text-align':'center'}"
					:header-cell-style="{'text-align':'center','background-color':'#d9d9d9','color':'#5a5a5a'}">
					<el-table-column prop="month" label="月份"></el-table-column>
					<el-table-column prop="storeName" label="门店"></el-table-column>
					<el-table-column label="业绩">
						<el-table-column label="剪发/￥">
							<template slot-scope="scope">
								{{scope.row.haircut}}
							</template>
						</el-table-column>
						<el-table-column prop="member" label="会员/￥"></el-table-column>
						<el-table-column prop="marketing" label="营销/￥"></el-table-column>
						<el-table-column prop="summary" label="总业绩/￥"></el-table-column>
					</el-table-column>
					<el-table-column label="成本 ">
						<el-table-column prop="rentCost" label="租金"></el-table-column>
						<el-table-column prop="laborCost" label="人工成本"></el-table-column>
						<el-table-column prop="distCost" label="摊分成本"></el-table-column>
						<el-table-column prop="totalCost" label="总成本"></el-table-column>
					</el-table-column>
					<el-table-column prop="profit" label="实际盈利"></el-table-column>
					<!-- <el-table-column prop="compare" label="同比"></el-table-column> -->
					<el-table-column label="编辑" width="110">
						<template slot-scope="scope">
							<el-button type="text" @click="edit(scope.row)">修改</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div style="text-align: center;">
					<el-pagination background @current-change="handleCurrentChange" @size-change="handleSizeChange"
						style="margin-top: 30px;" layout=" total, prev, pager, next, jumper"
						:page-size="[10, 20, 30, 50, 100]" :current-page="query.page" :total="query.total">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="修改成本" width="500px" :visible.sync="open">
			<el-form :inline="true" label-width="100px" style="width: 400px;" label-position="left">
				<el-form-item label="剪发业绩">
					<el-input v-model="formData.haircut"></el-input>
				</el-form-item>
				<el-form-item label="会员业绩">
					<el-input v-model="formData.member"></el-input>
				</el-form-item>
				<el-form-item label="营销业绩">
					<el-input v-model="formData.marketing"></el-input>
				</el-form-item>
				<el-form-item label="总业绩">
					<el-input v-model="formData.summary"></el-input>
				</el-form-item>
				<el-form-item label="租金成本">
					<el-input v-model="formData.rentCost"></el-input>
				</el-form-item>
				<el-form-item label="人工成本">
					<el-input v-model="formData.laborCost"></el-input>
				</el-form-item>
				<el-form-item label="摊分成本">
					<el-input v-model="formData.distCost"></el-input>
				</el-form-item>
				<el-form-item label="总成本">
					<el-input v-model="formData.totalCost"></el-input>
				</el-form-item>
				<el-form-item label="实际盈利">
					<el-input v-model="formData.profit"></el-input>
				</el-form-item>
				<!-- 				<el-form-item label="同比">
					<el-input v-model="formData.compare"></el-input>
				</el-form-item> -->
			</el-form>
			<div style="display: flex;width: 100%;text-align: center;margin-left: 30%;">
				<div>
					<el-button @click="open=false">取消</el-button>
				</div>
				<div>
					<el-button @click="save()" type="primary" style="margin-left: 30px;">保存</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		url
	} from '../../utils/index.js'
	export default {
		data() {
			return {
				url: url(),
				open: false,
				tableData: [],
				formData: [],
				query: {
					pageNum: 0,
					pageSize: 10
				}
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			getList() {
				let a = "?storeId=" + this.$route.query.storeId +
					"&pageNum=" + this.query.pageNum +
					"&pageSize=" + this.query.pageSize
				this.$http.get("dCost/list" + a).then(res => {
					this.tableData = res.body.data
					this.query.total = res.body.total
				})
			},
			edit(row) {
				this.formData = row;
				this.open = true
			},
			save() {
				this.$http.post("dCost/save", JSON.stringify(this.formData)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功")
						this.open = false
						this.getList();
					} else {
						this.$message.error("系统错误")
					}
				})
			},
			exprot() {
				window.location.assign(this.url + "dCost/export?storeId=" + this.$route.query.storeId);
			},
			handleCurrentChange(val) {
				this.query.page = val;
				this.getList()
			},
			handleSizeChange(val) {
				this.query.size = val;
				this.getList()
			},
			back01() {
				if (this.$route.query.month != null) {
					this.$router.push({
						path: '/cost',
						query: {
							month: this.$route.query.month
						},
					})
				}
			}
		},
	}
</script>

<style lang="less" scoped>
	.flex {
		display: flex;
	}

	.stitle {
		padding: 20px;
		width: 105px;
		height: 21px;
		font-size: 21px;
		font-family: SourceHanSansCN-Bold;
		font-weight: bold;
		color: #2D2D2D;
		line-height: 32px;
	}

	.box {
		margin-top: 20px;

		min-height: 651px;
		box-shadow: 2px 2px 4px 2px rgba(102, 102, 102, 0.5);
	}
</style>